import { render, staticRenderFns } from "./PersonaHistoricoAgencia.vue?vue&type=template&id=4be6eb6f&scoped=true"
import script from "./PersonaHistoricoAgencia.vue?vue&type=script&lang=js"
export * from "./PersonaHistoricoAgencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be6eb6f",
  null
  
)

export default component.exports